// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

// Import theme context
import { AppThemeProvider } from './contexts/ThemeContext';
import { BreakdownViewProvider } from './contexts/BreakdownViewContext';

// Import your actual page components
import LandingPage from './LandingPage';
import FlightBreakdownPage from './FlightBreakdown';
import Flights from './Flights';
import UserSettings from './UserSettings';
import FlightDataPage from './FlightDataPage';
import DriverDemoPage from './DriverDemoPage';
import SeatOnePage from './SeatOnePage';

// Import NavBar here
import NavBar from './NavBar';

// DEV-ONLY pages. The `dev/` directory is gitignored and absent from
// production builds. The require is inside a NODE_ENV === 'development'
// block which CRA/webpack dead-code-eliminates in production, so the
// missing module is never resolved during prod build.
let DevFixturesPage = null;
let DevBenchPage = null;
if (process.env.NODE_ENV === 'development') {
  try { DevFixturesPage = require('./dev/FixturesPage').default; } catch (e) {}
  try { DevBenchPage = require('./dev/BenchPage').default; } catch (e) {}
}

function AppContent() {
  return (
    <>
      <NavBar />

      {/* Spacer for fixed navbar - ensuring it's always 64px */}
      <Box sx={{ height: '64px', minHeight: '64px' }} />

      {/* Routes will render the specific page content */}
      <Routes>
        {/* Redirect base path '/' to the Flight Breakdown page */}
        <Route path="/" element={<Navigate replace to="/breakdown" />} />

        {/* Define routes for your application pages */}
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/breakdown" element={<FlightBreakdownPage />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/user-settings" element={<UserSettings />} />
        <Route path="/flight-data" element={<FlightDataPage />} />
        <Route path="/driver-demo" element={<DriverDemoPage />} />
        <Route path="/seat-one" element={<SeatOnePage />} />
        {DevFixturesPage && <Route path="/dev/fixtures" element={<DevFixturesPage />} />}
        {DevBenchPage && <Route path="/dev/bench" element={<DevBenchPage />} />}

        {/* Optional: Add a catch-all 404 Not Found route */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </>
  );
}

function App() {
  return (
    <AppThemeProvider>
      <Router>
        <BreakdownViewProvider>
          <AppContent />
        </BreakdownViewProvider>
      </Router>
    </AppThemeProvider>
  );
}

export default App;
